import { render } from "./AdminViewUsers.vue?vue&type=template&id=48ecb390"
import script from "./AdminViewUsers.vue?vue&type=script&lang=js"
export * from "./AdminViewUsers.vue?vue&type=script&lang=js"

import "./AdminViewUsers.vue?vue&type=style&index=0&id=48ecb390&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__